import { AssessmentSimple } from 'domain/entities/AssessmentEntity';
import { useState } from 'react';
import { LuChevronDown, LuRotateCcw } from 'react-icons/lu';
import styles from '../styles.module.scss';

type ConditionSectionProps = {
    assessmentData: AssessmentSimple;
    stationName?: string;
    onRecalculate: () => void;
};

export const ConditionSection = ({
    assessmentData,
    stationName,
    onRecalculate,
}: ConditionSectionProps) => {
    const [isOpen, setIsOpen] = useState(true);

    return (
        <section className={styles.condCard}>
            <div className={styles.condHeader} onClick={() => setIsOpen(!isOpen)}>
                <span className={styles.condTitle}>入力した条件</span>
                <LuChevronDown
                    className={`${styles.condToggleIcon} ${isOpen ? styles.condToggleIconOpen : ''}`}
                />
            </div>

            {isOpen && (
                <>
                    <div className={styles.condGrid}>
                        <div className={styles.condRow}>
                            <div className={styles.condItem}>
                                <span className={styles.condItemLabel}>築年数</span>
                                <span className={styles.condItemValue}>
                                    {assessmentData.age_building}年
                                </span>
                            </div>
                            <div className={styles.condItem}>
                                <span className={styles.condItemLabel}>専有面積</span>
                                <span className={styles.condItemValue}>
                                    {assessmentData.area}㎡
                                </span>
                            </div>
                        </div>
                        <div className={styles.condRow}>
                            <div className={styles.condItem}>
                                <span className={styles.condItemLabel}>最寄り駅</span>
                                <span className={styles.condItemValue}>{stationName ?? '-'}</span>
                            </div>
                            <div className={styles.condItem}>
                                <span className={styles.condItemLabel}>徒歩分数</span>
                                <span className={styles.condItemValue}>
                                    {assessmentData.on_foot_time}分
                                </span>
                            </div>
                        </div>
                    </div>

                    <button type="button" className={styles.recalcBtn} onClick={onRecalculate}>
                        <LuRotateCcw className={styles.recalcIcon} />
                        <span className={styles.recalcText}>条件を変えて再計算</span>
                    </button>
                </>
            )}
        </section>
    );
};
